import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useFlowDispatch } from "../../hooks/df";
export default function Radio(_a) {
    var field = _a.field, onChange = _a.onChange;
    var fieldConfig = field.config;
    if (!Array.isArray(fieldConfig.answerOptions))
        return null;
    var dispatch = useFlowDispatch();
    if (!dispatch)
        return null;
    var handleSelect = function (value) {
        onChange(value);
    };
    return (_jsx(_Fragment, { children: _jsx("div", { role: "radiogroup", "aria-label": "Options", className: "radio-group", children: fieldConfig.answerOptions.map(function (option, i) {
                return _jsx(RadioItem, { option: option, field: field, handleSelect: handleSelect }, "".concat(fieldConfig.fieldId, "-").concat(i));
            }) }) }));
}
function RadioItem(_a) {
    var field = _a.field, option = _a.option, handleSelect = _a.handleSelect;
    var isSelected = function () { return field.fieldValue === option.value; };
    return (_jsxs("button", { type: "button", role: "radio", "aria-checked": isSelected(), onClick: function (e) {
            e.preventDefault();
            handleSelect(option.value);
        }, className: "radio-option ".concat(isSelected() ? "selected" : ""), children: [option.imageUrl ? (_jsx("img", { src: option.imageUrl, alt: "", className: "icon-img" })) : option.customIconImage ? (_jsx("img", { src: option.customIconImage, alt: "", className: "icon-img" })) : option.fontAwesomeIconClass ? (_jsx("i", { className: "icon ".concat(option.fontAwesomeIconClass), "aria-hidden": "true" })) : null, _jsx("span", { children: option.text })] }));
}
